import { apiGet } from '../../../shared/api-client/index.js';

export interface MemberOption {
  id: string;
  userId: string;
  role: string;
  status: string;
  name: string;
  email: string;
}

export interface CompanyOption {
  id: string;
  name: string;
}

export async function listMembers(): Promise<MemberOption[]> {
  return apiGet<MemberOption[]>('/members');
}

export async function listCompanies(): Promise<CompanyOption[]> {
  return apiGet<CompanyOption[]>('/companies');
}
